import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import CodeFormPartial from 'components/CodeFormPartial';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import { OTP_LENGTH, RESET_PASSWORD_FORM } from '../../constants';
import { useOtpLockoutDuration } from '../../hooks';
import * as selectors from '../../selectors';
import { OtpLockInfo, OtpResendBtn } from '../OTP';
import validatorRules from './codeFormValidatorRules.json';
const ResetPasswordOtpForm = ()=>{
    var _formValues_values;
    const otpStatus = useSelector(selectors.otpStatus);
    const hasErrors = useSelector(selectors.hasOtpErrors);
    const formValues = useSelector(App.selectors.formSelector(RESET_PASSWORD_FORM));
    const verifyOtp = useAction(actions.verifyOtp);
    const clearErrors = useAction(actions.clearErrors);
    const onSetFormValue = useAction(App.actions.setFormValue, RESET_PASSWORD_FORM);
    const [isInProgress, setIsInProgress] = useState(false);
    const lockoutDuration = useOtpLockoutDuration(otpStatus);
    const submitForm = ({ otp })=>{
        setIsInProgress(true);
        verifyOtp(otp);
    };
    const processForm = App.hooks.useFormProcessing(RESET_PASSWORD_FORM, submitForm);
    useEffect(()=>()=>{
            clearErrors();
        }, []);
    useEffect(()=>{
        if (hasErrors) {
            setIsInProgress(false);
        }
    }, [
        hasErrors
    ]);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    const otp = formValues === null || formValues === void 0 ? void 0 : (_formValues_values = formValues.values) === null || _formValues_values === void 0 ? void 0 : _formValues_values.otp;
    const isOtp = !!otp && otp.length === OTP_LENGTH;
    return /*#__PURE__*/ _jsxs(Form, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx(OtpLockInfo, {
                lockoutDuration: lockoutDuration,
                hasErrors: hasErrors
            }),
            /*#__PURE__*/ _jsx(CodeFormPartial, {
                id: "otp",
                codeLength: OTP_LENGTH,
                isDisabled: !!lockoutDuration,
                onSetFormValue: onSetFormValue
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row flex-column-reverse flex-sm-row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(OtpResendBtn, {
                            lockoutDuration: lockoutDuration
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.continue,
                            className: "btn--block btn--filled",
                            isDisabled: !isOtp || !!lockoutDuration,
                            isInProgress: isInProgress
                        })
                    })
                ]
            })
        ]
    });
};
export default ResetPasswordOtpForm;
